<template>
	<LayoutScreen background="--background-base" max-width="500px" content-align="center">
		<template #content>
			<LayoutFlex padding="var(--size-24) var(--size-20)" gap="var(--size-16)" align-items="center">
				<!-- 64px badge = 24px icon + 20px padding; the X is Figma's #CB3152 (no DS token). -->
				<LayoutFlex
					padding="var(--size-20)"
					gap="0"
					background="--background-rose-alpha-low"
					corner-radius="var(--size-24)"
					aria-hidden="true"
				>
					<Icon type="ds_close" size="--size-24" color="#CB3152" />
				</LayoutFlex>
				<Text font="--heading-h3" color="--text-dark-primary" text-align="center">
					We couldn't update your payment method
				</Text>
				<Text font="--text-16-22-reg" color="--text-dark-primary" text-align="center">
					Please make sure you have sufficient funds and the payment method you selected is active, then try again.
				</Text>
			</LayoutFlex>
		</template>

		<template #footer>
			<LayoutFlex padding="0 var(--size-20) var(--size-24)" gap="var(--size-16)" align-items="center">
				<Button full-width @ds:click="onRetry">
					<Text font="--text-16-18-semi">Update payment method</Text>
				</Button>
				<Text font="--text-16-22-reg" color="--text-dark-primary" text-align="center">
					Any questions?
					<a class="payment-failed__support-link" :href="supportMailto" @click="onContactSupport">Contact support</a>
				</Text>
			</LayoutFlex>
		</template>
	</LayoutScreen>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { Button, Icon, LayoutFlex, LayoutScreen, Text } from '@simple-life-app/growth-ui-kova'
import { trackSupportEntryPoint, trackUpdatePaymentScreenView } from '@/analytics/events'
import { SUPPORT_EMAIL } from '@/config'

const router = useRouter()

const supportMailto = `mailto:${SUPPORT_EMAIL}`

onMounted(() => {
	trackUpdatePaymentScreenView('UPDATE_PAYMENT_METHOD_UNSUCCESS_SCREEN')
})

function onRetry() {
	// ?entry=unsuccess → the paywall reports entry_point=update_payment_method_unsuccess_screen.
	router.push({ path: '/payment/update', query: { entry: 'unsuccess' } })
}

function onContactSupport() {
	trackSupportEntryPoint('web_update_payment_method_unsuccess')
}
</script>

<style scoped>
/* DS Text ships `.text a { color: inherit }` at (0,2,1) specificity — the extra
   `.text a` prefix is needed for the brand-green link color to win. */
.text a.payment-failed__support-link {
	color: var(--background-brand-high);
	text-decoration: underline;
}
</style>
